import React, { useState } from "react";
import Modal from "react-modal";
import Swal from "sweetalert2";
import "bootstrap-icons/font/bootstrap-icons.css"; // Asegúrate de tener bootstrap-icons instalado

Modal.setAppElement("#root");

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "none",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    padding: "20px",
    maxWidth: "450px",
    width: "100%",
    maxHeight: "250px",
    overflow: "auto",
    fontFamily: "Roboto, sans-serif",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 102,
  },
};

const ProductButton = ({ onClick }) => {
  const [percentage, setPercentage] = useState(10);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const updatePrices = async (increase) => {
    const actionText = increase ? "aumentar" : "disminuir";
    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: `Estás a punto de ${actionText} los precios en ${percentage}%.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, ¡hazlo!",
      cancelButtonText: "No, cancelar",
    });

    if (result.isConfirmed) {
      onClick(increase, percentage);
      setModalIsOpen(false);
    } else {
      Swal.fire({
        title: "Cancelado",
        text: "Los cambios en los precios han sido cancelados.",
        icon: "info",
        confirmButtonText: "OK",
      });
      setModalIsOpen(false);
    }
  };

  const handlePercentageChange = (e) => {
    let newValue = e.target.value;
    if (newValue === "0") {
      newValue = "";
    }
    setPercentage(newValue);
  };

  const decrementPercentage = () => {
    setPercentage((prev) => {
      const num = parseInt(prev, 10) || 0;
      return num > 1 ? num - 1 : 1;
    });
  };

  const incrementPercentage = () => {
    setPercentage((prev) => {
      const num = parseInt(prev, 10) || 0;
      return num + 1;
    });
  };

  return (
    <div>
      <button className="new-task-button" onClick={() => setModalIsOpen(true)}>
        <i className="bi bi-sliders" style={{ marginRight: "5px" }}></i>Ajustar
        precios
      </button>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        style={customStyles}
        contentLabel="Ajuste de Precios"
      >
        <button className="modal-close" onClick={() => setModalIsOpen(false)}>
          <i className="bi bi-x-lg"></i>
        </button>
        <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
          Editar Ajuste de Precios
        </h2>

        {/* Contenedor para el input con botones de - y + */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "40px",
            marginBottom: "40px",
          }}
        >
          <button
            style={{
              backgroundColor: "#f0f0f0",
              border: "none",
              borderRadius: "50%",
              width: "40px",
              height: "40px",
              marginRight: "10px",
              cursor: "pointer",
            }}
            onClick={decrementPercentage}
          >
            <i className="bi bi-dash" style={{ fontSize: "1.2rem" }}></i>
          </button>

          {/* Input con el signo de porcentaje dentro, usando position: relative */}
          <div style={{ position: "relative", display: "inline-block" }}>
            <input
              type="number"
              value={percentage}
              onChange={handlePercentageChange}
              style={{
                width: "80px",
                textAlign: "center",
                fontSize: "1rem",
                border: "1px solid #ccc",
                borderRadius: "5px",
                padding: "6px",
                paddingRight: "24px", // espacio para el signo "%"
              }}
            />
            <span
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                pointerEvents: "none",
                color: "#999",
              }}
            >
              %
            </span>
          </div>

          <button
            style={{
              backgroundColor: "#f0f0f0",
              border: "none",
              borderRadius: "50%",
              width: "40px",
              height: "40px",
              marginLeft: "10px",
              cursor: "pointer",
            }}
            onClick={incrementPercentage}
          >
            <i className="bi bi-plus" style={{ fontSize: "1.2rem" }}></i>
          </button>
        </div>

        {/* Botones de acción */}
        <div style={{ textAlign: "center" }}>
          <button
            style={{
              marginRight: "10px",
              padding: "10px 20px",
              border: "none",
              borderRadius: "5px",
              backgroundColor: "#28a745",
              color: "#fff",
              cursor: "pointer",
            }}
            onClick={() => updatePrices(true)}
          >
            <i
              className="bi bi-arrow-up-circle"
              style={{ marginRight: "5px" }}
            ></i>
            Aumentar
          </button>

          <button
            style={{
              padding: "10px 20px",
              border: "none",
              borderRadius: "5px",
              backgroundColor: "#dc3545",
              color: "#fff",
              cursor: "pointer",
            }}
            onClick={() => updatePrices(false)}
          >
            <i
              className="bi bi-arrow-down-circle"
              style={{ marginRight: "5px" }}
            ></i>
            Disminuir
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default ProductButton;
